const csrfToken = document.getElementsByName('csrf-token')[0].content
export default csrfToken